import React from 'react'
import { Box, Skeleton } from '@mui/material'

interface EmptyPetsitterSlotProps {
  isLoading?: boolean
}

export const EmptyPetsitterSlot: React.FC<EmptyPetsitterSlotProps> = ({ isLoading }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
      }}
    >
      {isLoading ? (
        <>
          <Skeleton
            variant="rounded"
            width={44}
            height={44}
            sx={{
              borderRadius: '12px',
            }}
          />
          <Skeleton variant="rounded" width={44} height={12} />
        </>
      ) : (
        <>
          <Box
            sx={{
              border: '1px solid #E8E8EA',
              borderRadius: '12px',
            }}
          >
            <Box
              sx={{
                height: '44px',
                width: '44px',
                backgroundColor: '#F6F6F6',
                borderRadius: '12px',
                border: '1px solid #F9F9F9',
              }}
            />
          </Box>
          <Box
            sx={{
              height: '12px',
              width: '100%',
              backgroundColor: '#E8E8EA',
              borderRadius: '4px',
              opacity: '50%',
            }}
          />
        </>
      )}
    </Box>
  )
}
